export class GuardDataKeys {
    public static readonly PERMITTED_USER_ROLES = 'permittedUserRoles';
    public static readonly PERMITTED_USER_STATUSES = 'permittedUserStatuses';
}
